<template>
  <v-container class="pa-0">
    <v-container class="d-flex justify-space-between px-0">
      <span class="person-index"
        >{{ $t('adminContact.person') }} {{ index + 1 }}</span
      >
      <v-btn
        icon
        color="primary"
        @click="removeEmergencyContact()"
        v-if="index > 0">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-container>
    <v-select
      v-model="relationship"
      ref="relationship"
      :items="emergencyContactsRelationships"
      filled
      item-text="name"
      item-value="code"
      :label="$t('adminContact.relation')"
      :rules="[rules.required]"
      class="required" />
    <v-text-field
      v-model="lastName"
      :label="$t('global.lastName')"
      filled
      class="required"
      :rules="[rules.required]">
    </v-text-field>
    <v-text-field
      v-model="firstName"
      :label="$t('global.firstName')"
      filled
      class="required"
      :rules="[rules.required]">
    </v-text-field>
    <phone-field
      v-model="phone"
      :label="$t('global.mobilePhone')"
      required>
    </phone-field>
  </v-container>
</template>

<script>
import { phoneRule, requiredRule } from '@/helpers/validationRules';
import { mapState } from 'vuex';
import PhoneField from "@/components/ui/PhoneField.vue";

export default {
  name: 'EmergencyContactForm',
  components: {PhoneField},
  data() {
    return {
      uid: this.contact.uid,
      relationship: this.contact.relationship,
      lastName: this.contact.lastName,
      firstName: this.contact.firstName,
      phone: this.contact.phone,
      rules: {
        required: requiredRule,
        phone: (value) => phoneRule(value)
      }
    };
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    index: { type: Number, required: true }
  },
  computed: {
    ...mapState('preAdmission', ['emergencyContactsRelationships']),
    updateData() {
      const { lastName, firstName, phone, relationship } = this;
      return { lastName, firstName, phone, relationship };
    }
  },
  watch: {
    updateData: {
      handler() {
        this.$emit('input', {
          uid: this.contact.uid,
          relationship: this.relationship,
          lastName: this.lastName,
          firstName: this.firstName,
          phone: this.phone
        });
      },
      deep: true
    }
  },
  methods: {
    removeEmergencyContact() {
      this.$emit('removeEmergencyContact', this.contact.uid);
    }
  }
};
</script>
<style lang="scss" scoped>
.person-index {
  font-weight: bold;
}
</style>
